import { render, staticRenderFns } from "./LogoutHeader.vue?vue&type=template&id=6b3f76da&"
import script from "./LogoutHeader.vue?vue&type=script&lang=js&"
export * from "./LogoutHeader.vue?vue&type=script&lang=js&"
import style0 from "./LogoutHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports